import { Outlet } from "react-router-dom";
import { Fragment } from "react";
import Submission from "../../components/Submission";
import Header from "./Header";

function FormRouteType() {
  return (
    <Fragment>
      <Header />
      <Outlet />
      <Submission />
    </Fragment>
  );
}

export default FormRouteType;
